/**
 * Adapter: delegates ILayerManager port to services/layerManager LayerManager.
 */
import type { LayerManager } from '../../../services/layerManager';
import { getLayerManager } from '../../../services/layerManagerInstance';
import type { UndergroundLayer } from '../../../types/underground';
import type { ILayerManager } from '../../domain/ports/ILayerManager';

export class LayerManagerAdapter implements ILayerManager {
  constructor(private readonly manager: LayerManager = getLayerManager()) {}

  switchToLayer(targetLayer: UndergroundLayer, duration = 1000): void {
    this.manager.switchToLayer(targetLayer, duration);
  }

  getCurrentLayer(): UndergroundLayer {
    return this.manager.getCurrentState().currentLayer;
  }

  isTransitioning(): boolean {
    return this.manager.getCurrentState().isTransitioning;
  }
}